import React, { useEffect } from "react";
import axios from "axios";
import { LinkContainer } from "react-router-bootstrap";
import { Table, Button, Row, Col, Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Message from "../components/Message";
import Loader from "../components/Loader";
import Paginate from "../components/Paginate";
import { calculatePrice } from "../utils/calculatePrice";
import {
  listShippingMethods,
  deleteShippingMethod,
  createShippingMethod,
} from "../actions/shippingMethodActions";
import { SHIPPING_METHOD_CREATE_RESET } from "../constants/shippingMethodConstants";

const ShippingMethodListScreen = ({ history, match }) => {
  const pageNumber = match.params.pageNumber || 1;

  const dispatch = useDispatch();

  const shippingMethodList = useSelector((state) => state.shippingMethodList);
  const { loading, error, shippingMethods, page, pages } = shippingMethodList;

  const shippingMethodDelete = useSelector(
    (state) => state.shippingMethodDelete
  );
  const {
    loading: loadingDelete,
    error: errorDelete,
    success: successDelete,
  } = shippingMethodDelete;

  const shippingMethodCreate = useSelector(
    (state) => state.shippingMethodCreate
  );
  const {
    loading: loadingCreate,
    error: errorCreate,
    success: successCreate,
    shippingMethod: createdShippingMethod,
  } = shippingMethodCreate;

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  useEffect(() => {
    dispatch({ type: SHIPPING_METHOD_CREATE_RESET });

    if (!userInfo || !userInfo.isAdmin) {
      history.push("/login");
    }
    dispatch(listShippingMethods("", pageNumber));
  }, [
    dispatch,
    history,
    userInfo,
    successDelete,
    createdShippingMethod,
    pageNumber,
  ]);

  const deleteHandler = (id) => {
    if (window.confirm("Are you sure")) {
      dispatch(deleteShippingMethod(id));
    }
  };

  const createShippingMethodHandler = () => {
    history.push("/shipping-methods-add");
  };

  return (
    <>
      <Row className="align-items-center">
        <Col>
          <h1>ShippingMethods</h1>
        </Col>
        <Col className="text-right">
          <Button className="my-3" onClick={createShippingMethodHandler}>
            <i className="fas fa-plus"></i> Create Shipping Method
          </Button>
        </Col>
      </Row>
      {loadingDelete && <Loader />}
      {errorDelete && <Message variant="danger">{errorDelete}</Message>}
      {loadingCreate && <Loader />}
      {errorCreate && <Message variant="danger">{errorCreate}</Message>}
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">{error}</Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>COMPANY</th>
                <th>DESCRIPTION</th>
                <th>Price Domestic</th>
                <th>Price Eu</th>
                <th>Price NonEu</th>
                <th>Price OverSize</th>
                <th>Oversize Weight</th>
                <th>Oversize Size</th>
                <th>Taxes</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {shippingMethods.map((shippingMethod) => (
                <tr key={shippingMethod._id}>
                  <td>{shippingMethod.cuid}</td>
                  <td>
                    {shippingMethod.company}{" "}
                    {shippingMethod.defaultValue ? (
                      <i className="fas fa-check"></i>
                    ) : (
                      ``
                    )}
                  </td>
                  <td>{shippingMethod.description}</td>
                  <td>
                    {shippingMethod.priceDomestic
                      ? calculatePrice(shippingMethod.priceDomestic)
                      : ""}
                  </td>
                  <td>
                    {shippingMethod.priceEu
                      ? calculatePrice(shippingMethod.priceEu)
                      : ""}
                  </td>
                  <td>
                    {shippingMethod.priceNonEu
                      ? calculatePrice(shippingMethod.priceNonEu)
                      : ""}
                  </td>
                  <td>
                    {shippingMethod.priceOverSize
                      ? calculatePrice(shippingMethod.priceOverSize)
                      : ""}
                  </td>
                  <td>{shippingMethod.oversizeWeight}</td>
                  <td>{shippingMethod.oversizeSize}</td>
                  <td>{shippingMethod.taxes}</td>
                  <td>{shippingMethod.url}</td>
                  <td>
                    <LinkContainer
                      to={`/shipping-methods/${shippingMethod._id}/edit`}
                    >
                      <Button variant="warning" className="btn-sm">
                        <i className="fas fa-edit"></i>
                      </Button>
                    </LinkContainer>
                    <Button
                      variant="danger"
                      className="btn-sm"
                      onClick={() => deleteHandler(shippingMethod._id)}
                    >
                      <i className="fas fa-trash"></i>
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Paginate pages={pages} page={page} isAdmin={true} />
        </>
      )}
    </>
  );
};

export default ShippingMethodListScreen;
